import { useEffect } from 'react';
import './Toast.css';

/**
 * A brief, self-dismissing confirmation message — for telling someone an
 * action they just took (often one that also navigated them away, like a
 * delete) actually succeeded, rather than leaving them to guess.
 */
function Toast({ message, onDismiss, duration = 3000 }) {
  useEffect(() => {
    if (!message) return undefined;
    const timer = setTimeout(onDismiss, duration);
    return () => clearTimeout(timer);
  }, [message, duration, onDismiss]);

  if (!message) return null;

  return <div className="toast">{message}</div>;
}

export default Toast;
